export function PageLoader() {
  return (
    <div className="flex items-center justify-center h-screen bg-[#f8fafc]">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#0052cc]" />
    </div>
  );
}
